import * as actions from '../actions/workbench';
import * as types from '../types/workbench';
// @ts-ignore
import _ from 'lodash';

export const menuInitState: Partial<types.ProjectList> = {
  loading: false,
  optionsLoaded: false,
  conditions: {},
};

const initState = {};

export default function(
  state: Partial<types.ProjectList> = initState,
  action: actions.WorkbenchActions,
): Partial<types.ProjectList> {
  const menuKey = _.snakeCase(action.menuKey);

  switch (action.type) {
    case actions.GET_LIST_SUCCESS: {
      const { data: { list, conditions } } = action;
      const menuData = state[menuKey] || menuInitState;
      return {
        ...state, [menuKey]: {
          ...menuData,
          list, conditions,
          loading: false,
        },
      };
    }
    case actions.GET_LIST_OPTIONS_SUCCESS: {
      const { data } = action;
      const menuData = state[menuKey] || menuInitState;
      return {
        ...state, [menuKey]: {
          ...menuData,
          filterOptions: data && data.reduce((obj, item) => {
            obj[item.key] = item;
            return obj;
          }, {}),
          optionsLoaded: true,
        },
      };
    }
    case actions.CHANGE_CONDITIONS: {
      return { ...state, conditions: { ...state.conditions, ...action.data } };
    }
    case actions.LOADING: {
      const menuData = state[menuKey] || menuInitState;
      return {
        ...state, [menuKey]: {
          ...menuData,
          loading: true,
          checkedState: {},
        },
      };
    }

    case actions.CHANGE_LIST_FINISH_TYPE: {
      const {
        data: { menuKey, id },
      } = action;
      const menuData = state[menuKey];
      const {list: {res = []}, list } = menuData;
      const newRes = res.map((item: any) => {
        if (item.id === id) {
          return {
            ...item,
            finished: !item.finished,
          };
        }
        return {...item};
      });

      return {
        ...state,
        [menuKey]: {
          ...menuData,
          list: {...list, res: newRes },
        },
      };
    }
  }
  return state;
}
